<template>
    <div class="hide-pages-popover-content">
        <pdf-page-selector
            v-model="hiddenPageIndexes"
            :pdf="props.pdf"
            selectable
            allow-bulk-actions
            select-all-label="Hide all pages"
            clear-selection-label="Unhide all pages"
            preview-height="20vh"
        >
            <template #current-page-label="{ selected }">
                {{ selected ? 'Unhide current page' : 'Hide current page' }}
            </template>
        </pdf-page-selector>
    </div>
</template>

<script setup lang="ts">
import {
    computed, ref, watch,
} from 'vue';
import PdfPageSelector from './PdfPageSelector.vue';

const props = defineProps<{ pdf: Uint8Array}>();

const emit = defineEmits<{
    'update:hiddenPages': [Array<number>];
    'update:hiddenPagesLabel': [string];
}>();

const hiddenPageIndexes = ref<Array<number>>([]);
const hiddenPages = computed<Array<number>>(() => hiddenPageIndexes.value.map(pageIndex => pageIndex + 1).sort((a, b) => a - b));
const hiddenPagesLabel = computed<string>(() => (hiddenPages.value.length ? hiddenPages.value.join(', ') : 'None'));

watch(hiddenPages, () => {
    emit('update:hiddenPages', hiddenPages.value);
}, { immediate: true });

watch(hiddenPagesLabel, () => {
    emit('update:hiddenPagesLabel', hiddenPagesLabel.value);
}, { immediate: true });
</script>

<style lang="scss" scoped>
.hide-pages-popover-content {
    width: 25vw;
    display: flex;
    flex-direction: column;
    padding: var(--defaultSpacing);
    gap: var(--defaultSpacing);
}
</style>
